import script from "./BigBlackCard.vue?vue&type=script&setup=true&lang=js"
export * from "./BigBlackCard.vue?vue&type=script&setup=true&lang=js"

import "./BigBlackCard.vue?vue&type=style&index=0&id=c1fe1a12&lang=scss&scoped=true"

import exportComponent from "/Users/matteo.direnzo/Documents/TVA/eni-digit_eni-storia/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c1fe1a12"]])

export default __exports__